import React, { useState } from 'react';
import axios from 'axios';
import CONFIG from '../config';

// Login page for Bill Management.
// It checks the email/password against the existing rate-system login,
// stores the returned session token as "fxToken", then tells App.js to continue.
function Login({ onLogin }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [busy, setBusy]         = useState(false);

  const handleLogin = async () => {
    setError('');
    if (!email || !password) {
      setError('Please enter both email and password.');
      return;
    }
    setBusy(true);
    try {
      // Ask the rate system to check the password and give us a session token.
      const res = await axios.post(
        `${CONFIG.AUTH_API}/users/login`,
        { email: email.trim(), password: password }
      );

      const data = res.data || {};
      // Be flexible about the token field name (different builds name it differently).
      const token =
        data.token || data.accessToken || data.sessionToken ||
        (data.data && (data.data.token || data.data.accessToken)) || '';

      if (!token) {
        setError('Login succeeded but no session token was returned. Please tell support.');
        setBusy(false);
        return;
      }

      // Save the token so every page can use it.
      localStorage.setItem('fxToken', token);

      // Hand control back to App.js to load the app.
      if (onLogin) onLogin(token);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401 || status === 400) {
        setError('Invalid email or password.');
      } else if (err?.message?.includes('Network')) {
        setError('Cannot reach the login server. Please check your connection.');
      } else {
        setError('Login failed. Please try again.');
      }
      setBusy(false);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.brandRow}>
          <div style={styles.logoBox}>FX</div>
          <div>
            <div style={styles.brandTitle}>FX CAPITAL INDIA</div>
            <div style={styles.brandSub}>Bill Management Portal</div>
          </div>
        </div>

        <div style={styles.divider} />

        <label style={styles.label}>EMAIL ADDRESS</label>
        <input
          style={styles.input}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder="you@example.com"
          autoFocus
        />

        <label style={styles.label}>PASSWORD</label>
        <input
          style={styles.input}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder="Your password"
        />

        {error && <div style={styles.error}>{error}</div>}

        <button style={{ ...styles.button, opacity: busy ? 0.7 : 1 }}
          onClick={handleLogin} disabled={busy}>
          {busy ? 'Signing in…' : 'SIGN IN'}
        </button>

        <div style={styles.footer}>Secure access — FX Capital India</div>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: '#0a0f1c',
    fontFamily: 'system-ui, Arial, sans-serif', padding: '20px',
  },
  card: {
    width: '100%', maxWidth: '420px', background: '#131c2e',
    border: '1px solid #1f2d45', borderRadius: '16px', padding: '36px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
  },
  brandRow: { display: 'flex', alignItems: 'center', gap: '14px' },
  logoBox: {
    width: '54px', height: '54px', borderRadius: '12px',
    background: 'linear-gradient(135deg,#c9a227,#8a6d1a)', color: '#1a1a1a',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: 800, fontSize: '20px',
  },
  brandTitle: { color: '#c9a227', fontWeight: 700, letterSpacing: '1px', fontSize: '18px' },
  brandSub: { color: '#7f8da3', fontSize: '13px', marginTop: '2px' },
  divider: { height: '1px', background: '#1f2d45', margin: '24px 0' },
  label: { display: 'block', color: '#7f8da3', fontSize: '11px',
    fontWeight: 700, letterSpacing: '1px', marginBottom: '6px', marginTop: '14px' },
  input: {
    width: '100%', padding: '12px 14px', borderRadius: '8px',
    border: '1px solid #2a3a55', background: '#e8edf5', color: '#111',
    fontSize: '15px', boxSizing: 'border-box',
  },
  error: {
    marginTop: '16px', padding: '10px 14px', borderRadius: '8px',
    background: 'rgba(220,38,38,0.12)', border: '1px solid rgba(220,38,38,0.4)',
    color: '#f87171', fontSize: '14px',
  },
  button: {
    width: '100%', marginTop: '22px', padding: '14px',
    borderRadius: '8px', border: 'none', cursor: 'pointer',
    background: 'linear-gradient(135deg,#c9a227,#8a6d1a)', color: '#1a1a1a',
    fontWeight: 800, fontSize: '15px', letterSpacing: '1px',
  },
  footer: { textAlign: 'center', color: '#5a6a82', fontSize: '12px', marginTop: '20px' },
};

export default Login;